import React from "react";
import styles from "./History.module.css";
import Footer from "../../components/ui/Footer";
import Navbar from "../../components/ui/Navbar";
import { NavLink, Outlet, useNavigate, useLocation } from "react-router-dom";
import Menu from "../../components/ui/Menu";
import { useSelector } from "react-redux";

function History(props) {
  const userDetails = useSelector((state) => state.userData.personalInfo);
  const navigate = useNavigate();
  const location = useLocation();

  const accountType = useSelector(
    (state) => state.userData.loginData.account_type
  );

  return (
    <div className={styles.page}>
      <div className="menu" onClick={() => props.setShowMenu(false)}>
        {props.showMenu && <Menu setShowMenu={props.setShowMenu} />}
      </div>
      <Navbar title="History" setShowMenu={props.setShowMenu} />
      <div className={styles.body}>

        {/* ── Wallet card ── */}
        <div className={styles.body_header}>
          <div className={styles.wallet_left}>
            <div className={styles.wallet_icon_box}>
              <svg width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="2" y="6" width="20" height="14" rx="3" stroke="#1814F3" strokeWidth="2"/>
                <path d="M2 10h20" stroke="#1814F3" strokeWidth="2"/>
                <path d="M6 3l4-1h4l4 1" stroke="#1814F3" strokeWidth="1.5" strokeLinecap="round"/>
                <circle cx="17" cy="15" r="1.5" fill="#1814F3"/>
              </svg>
            </div>
            <div className={styles.wallet_text}>
              <p className={styles.wallet_label}>Wallet Balance</p>
              <p className={styles.wallet_balance}>
                ₦{Number(userDetails?.wallet?.balance || 0).toLocaleString()}
              </p>
            </div>
          </div>
          <div className={styles.wallet_illustration}>
            <svg width="80" height="70" viewBox="0 0 100 80" fill="none" xmlns="http://www.w3.org/2000/svg">
              {/* Wallet Back */}
              <rect x="15" y="20" width="75" height="50" rx="8" fill="#D0C5FF" />
              {/* Money */}
              <rect x="25" y="10" width="55" height="30" rx="3" fill="#88D4B0" transform="rotate(-5 25 10)" />
              <rect x="25" y="10" width="55" height="30" rx="3" fill="#A5ECD2" />
              <circle cx="52.5" cy="25" r="8" fill="#88D4B0" />
              {/* Wallet Front */}
              <rect x="10" y="25" width="80" height="45" rx="8" fill="#907BFF" />
              {/* Wallet Flap */}
              <path d="M10 25C10 20.5817 13.5817 17 18 17H82C86.4183 17 90 20.5817 90 25V35C90 45 50 55 50 55C50 55 10 45 10 35V25Z" fill="#755FFF" />
              {/* Button */}
              <circle cx="50" cy="45" r="5" fill="#FFD166" />
              {/* Coins */}
              <circle cx="85" cy="60" r="10" fill="#FFD166" />
              <circle cx="85" cy="60" r="7" fill="#FFB703" />
              <circle cx="75" cy="70" r="8" fill="#FFD166" />
              <circle cx="75" cy="70" r="5" fill="#FFB703" />
            </svg>
          </div>
        </div>

        {/* ── Tabs + content ── */}
        <div className={styles.body_inner}>
          <div className={styles.body_inner_header}>
            {location.pathname === "/pin-history/sold-pins" ||
            location.pathname === "/pin-history/active-sold-pins" ||
            location.pathname === "/pin-history/exported-pins" ||
            location.pathname === "/pin-history/used-sold-pins" ||
            location.pathname === "/pin-history/bought-pins"
              ? (() => {
                  const pinTabs = [
                    ...(accountType === "DISTRIBUTOR"
                      ? [
                          { to: "/pin-history/sold-pins",        label: "Sold Pins"    },
                          { to: "/pin-history/active-sold-pins", label: "Active Sold"  },
                          { to: "/pin-history/used-sold-pins",   label: "Used Sold"    },
                        ]
                      : []),
                    { to: "/pin-history/exported-pins", label: "Exported Pins" },
                    { to: "/pin-history/bought-pins",   label: "Bought Pins"   },
                  ];
                  return (
                    <>
                      <div className={styles.tabs_desktop}>
                        {pinTabs.map(({ to, label }) => (
                          <NavLink
                            key={to}
                            to={to}
                            end
                            className={({ isActive }) =>
                              `${styles.link} ${isActive ? styles.active : ""}`
                            }
                          >
                            {label}
                          </NavLink>
                        ))}
                      </div>
                      <div className={styles.tabs_mobile}>
                        <select
                          className={styles.tab_select}
                          value={location.pathname}
                          onChange={(e) => navigate(e.target.value)}
                        >
                          {pinTabs.map(({ to, label }) => (
                            <option key={to} value={to}>
                              {label}
                            </option>
                          ))}
                        </select>
                      </div>
                    </>
                  );
                })()
              : [
                  ...(accountType !== "DISTRIBUTOR"
                    ? [{ to: "/history", label: "Orders", exact: true }]
                    : []),
                  { to: "/history/credit", label: "Credit" },
                  { to: "/history/debit",   label: "Debit"  },
                ].map(({ to, label, exact }) => (
                  <NavLink
                    key={to}
                    to={to}
                    end={exact}
                    className={({ isActive }) =>
                      `${styles.link} ${isActive ? styles.active : ""}`
                    }
                  >
                    {label}
                  </NavLink>
                ))}
          </div>

          <Outlet />
        </div>
      </div>
      <Footer contained />
    </div>
  );
}

export default History;
